import { render, staticRenderFns } from "./nshop-order-view-pins.vue?vue&type=template&id=c404e704&"
import script from "./nshop-order-view-pins.vue?vue&type=script&lang=js&"
export * from "./nshop-order-view-pins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports